/**
 * Q’LEX games. Swap the active game with data-game / the Game id setting.
 *
 * Runner feel is based on the MIT-licensed Chrome Dino recreation
 * https://github.com/KarthikNedunchezhiyan/google-chrome-dino
 * (variable jump, milestone speed, HI score, flying hazards).
 * Pixel art is original Q’LEX 1-bit (Q runner + construction icons).
 * Not Chrome/Google sprites. Palette stays ink / warn / accent.
 */
(function () {
  const root = document.getElementById("qlexGame");
  const canvas = document.getElementById("qlexGameCanvas");
  if (!root || !canvas) return;

  const games = {
    runner: startRunner,
  };

  const id = root.getAttribute("data-game") || "runner";
  (games[id] || games.runner)(root, canvas);

  function themeInk() {
    const dark = document.documentElement.getAttribute("data-theme") === "dark";
    return {
      ink: dark ? "#ffffff" : "#0a0a0a",
      muted: dark ? "#8a8a8a" : "#5a5a5a",
      accent: dark ? "#ff0000" : "#e00000",
      ground: dark ? "#6a6a6a" : "#9a9a9a",
      warn: dark ? "#ffb000" : "#e67a00",
      stripe: dark ? "#0a0a0a" : "#111111",
      sky: dark ? "#0a0a0a" : "#f3f3f3",
      far: dark ? "#262626" : "#e4e4e4",
      mid: dark ? "#323232" : "#d6d6d6",
      rail: dark ? "#333333" : "#cfcfcf",
      road: dark ? "#121212" : "#d8d8d8",
      dash: dark ? "#2a2a2a" : "#c0c0c0",
    };
  }

  function padScore(n) {
    return String(Math.max(0, Math.floor(n))).padStart(5, "0").split("").join(" ");
  }

  function startRunner(host, canvasEl) {
    const ctx = canvasEl.getContext("2d");
    const hud = document.getElementById("qlexGameHud");
    const overlay = document.getElementById("qlexGameOverlay");
    const rec = document.getElementById("qlexGameRec");
    const recLink = document.getElementById("qlexGameRecLink");
    const recImg = document.getElementById("qlexGameRecImg");
    const recTitle = document.getElementById("qlexGameRecTitle");
    const recPrice = document.getElementById("qlexGameRecPrice");
    const namePanel = document.getElementById("qlexGameName");
    const nameSlots = document.getElementById("qlexGameNameSlots");
    const nameSave = document.getElementById("qlexGameNameSave");
    const boardPanel = document.getElementById("qlexGameBoard");
    const boardList = document.getElementById("qlexGameBoardList");
    const skaterSheets = { light: null, dark: null };
    const duckSheets = { light: null, dark: null };
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    let duckLatch = false;
    let duckPressAt = 0;

    function cloneSprite(el) {
      const img = new Image();
      if (!el) return img;
      img.decoding = "async";
      img.src = el.currentSrc || el.src || "";
      return img;
    }

    const skaterImg = cloneSprite(document.getElementById("qlexSkaterSprite"));
    const duckImg = cloneSprite(document.getElementById("qlexDuckSprite"));

    function buildInkSheet(img, dark, radius) {
      if (!img || !img.naturalWidth) return null;
      const srcW = img.naturalWidth;
      const srcH = img.naturalHeight;
      let sx = 0;
      let sy = 0;
      let sw = srcW;
      let sh = srcH;
      try {
        const probe = document.createElement("canvas");
        probe.width = srcW;
        probe.height = srcH;
        const pctx = probe.getContext("2d", { willReadFrequently: true });
        pctx.drawImage(img, 0, 0);
        const data = pctx.getImageData(0, 0, srcW, srcH).data;
        let minX = srcW;
        let minY = srcH;
        let maxX = 0;
        let maxY = 0;
        for (let y = 0; y < srcH; y++) {
          for (let x = 0; x < srcW; x++) {
            if (data[(y * srcW + x) * 4 + 3] > 24) {
              if (x < minX) minX = x;
              if (y < minY) minY = y;
              if (x > maxX) maxX = x;
              if (y > maxY) maxY = y;
            }
          }
        }
        if (maxX >= minX) {
          sx = minX;
          sy = minY;
          sw = maxX - minX + 1;
          sh = maxY - minY + 1;
        }
      } catch (err) {
        /* tainted image: use the full frame */
      }
      const pad = radius + 2;
      const sheet = document.createElement("canvas");
      sheet.width = sw + pad * 2;
      sheet.height = sh + pad * 2;
      const sctx = sheet.getContext("2d");
      const step = Math.max(1, Math.floor(radius / 10));
      for (let dx = -radius; dx <= radius; dx += step) {
        for (let dy = -radius; dy <= radius; dy += step) {
          if (dx * dx + dy * dy > radius * radius) continue;
          sctx.drawImage(img, sx, sy, sw, sh, pad + dx, pad + dy, sw, sh);
        }
      }
      sctx.drawImage(img, sx, sy, sw, sh, pad, pad, sw, sh);
      if (dark) colorizeDarkSheet(sheet);
      return sheet;
    }

    function colorizeDarkSheet(sheet) {
      try {
        const ctx = sheet.getContext("2d", { willReadFrequently: true });
        const img = ctx.getImageData(0, 0, sheet.width, sheet.height);
        const d = img.data;
        for (let i = 0; i < d.length; i += 4) {
          if (d[i + 3] < 16) continue;
          const r = d[i];
          const g = d[i + 1];
          const b = d[i + 2];
          if (r > g + 18 && r > b + 18) {
            const t = Math.min(1, Math.max(0.45, r / 255));
            d[i] = 255;
            d[i + 1] = Math.round(16 + (1 - t) * 32);
            d[i + 2] = Math.round(16 + (1 - t) * 20);
          } else {
            d[i] = 255;
            d[i + 1] = 255;
            d[i + 2] = 255;
          }
        }
        ctx.putImageData(img, 0, 0);
      } catch (err) {
        const ctx = sheet.getContext("2d");
        ctx.globalCompositeOperation = "source-in";
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, sheet.width, sheet.height);
      }
    }

    function skaterSheet(dark) {
      const key = dark ? "dark" : "light";
      if (!skaterSheets[key]) skaterSheets[key] = buildInkSheet(skaterImg, dark, 18);
      return skaterSheets[key];
    }

    function duckSheet(dark) {
      const key = dark ? "dark" : "light";
      if (!duckSheets[key]) duckSheets[key] = buildInkSheet(duckImg, dark, 12);
      return duckSheets[key];
    }

    function bustSheets(sheets, img, el) {
      const refresh = () => {
        sheets.light = null;
        sheets.dark = null;
      };
      img.addEventListener("load", refresh);
      if (el) {
        el.addEventListener("load", () => {
          img.src = el.currentSrc || el.src;
          refresh();
        });
      }
      if (img.decode) img.decode().then(refresh).catch(() => {});
    }
    bustSheets(skaterSheets, skaterImg, document.getElementById("qlexSkaterSprite"));
    bustSheets(duckSheets, duckImg, document.getElementById("qlexDuckSprite"));
    const WORLD_W = 800;
    const WORLD_H = 280;
    const HI_KEY = "qlex_game_hi";
    const LB_KEY = "qlex_game_leaders";
    const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    const SPEED_START = 4;
    const SPEED_MAX = 8;
    const SPEED_STEP = 0.1;
    const JUMP_V = -9.2;
    const JUMP_HOLD = -0.34;
    const JUMP_HOLD_FRAMES = 14;
    const GRAVITY = 0.5;

    let catalog = [];
    try {
      catalog = JSON.parse(document.getElementById("qlexGameProducts")?.textContent || "[]");
      if (!Array.isArray(catalog)) catalog = [];
    } catch (e) {
      catalog = [];
    }
    let lastRecHandle = "";
    let hiScore = 0;
    try {
      hiScore = parseInt(localStorage.getItem(HI_KEY) || "0", 10) || 0;
    } catch (e) {
      hiScore = 0;
    }

    const state = {
      running: false,
      dead: false,
      diedAt: 0,
      time: 0,
      score: 0,
      scoreAcc: 0,
      speed: SPEED_START,
      milestone: 0,
      holdJump: false,
      holdLeft: 0,
      duckAmt: 0,
      ducking: false,
      enteringName: false,
      nameLetters: ["A", "A", "A"],
      nameIndex: 0,
      pendingScore: 0,
      youEntry: null,
      player: { x: 32, y: 0, w: 68, h: 70, standW: 68, standH: 70, duckW: 112, duckH: 36, vy: 0, grounded: true },
      obstacles: [],
      groundY: WORLD_H - 36,
      gapLeft: 320,
      flyGap: 520,
      scroll: 0,
    };

    const clouds = [
      { x: 70, y: 26, w: 40 },
      { x: 360, y: 20, w: 28 },
      { x: 640, y: 32, w: 36 },
    ];
    const SKYLINE_SPAN = 900;
    const skyline = [
      { kind: "block", x: 24, w: 18, h: 32 },
      { kind: "willis", x: 70 },
      { kind: "block", x: 150, w: 22, h: 44 },
      { kind: "block", x: 200, w: 14, h: 28 },
      { kind: "hancock", x: 250 },
      { kind: "block", x: 330, w: 26, h: 38 },
      { kind: "aon", x: 390 },
      { kind: "block", x: 440, w: 16, h: 26 },
      { kind: "trump", x: 490 },
      { kind: "block", x: 560, w: 34, h: 40 },
      { kind: "block", x: 640, w: 18, h: 30 },
      { kind: "block", x: 700, w: 28, h: 48 },
      { kind: "block", x: 780, w: 16, h: 28 },
    ];

    function size() {
      const stage = host.querySelector(".game-stage");
      const cssW = Math.max(280, Math.round(stage.clientWidth || host.clientWidth || WORLD_W));
      const cssH = Math.max(120, Math.round(stage.clientHeight || (cssW * WORLD_H) / WORLD_W));
      canvasEl.width = Math.round(cssW * dpr);
      canvasEl.height = Math.round(cssH * dpr);
      ctx.imageSmoothingEnabled = false;
      ctx.setTransform((dpr * cssW) / WORLD_W, 0, 0, (dpr * cssH) / WORLD_H, 0, 0);
      state.groundY = WORLD_H - 36;
      if (!state.running || state.player.grounded) {
        state.player.y = state.groundY - state.player.h;
      }
    }

    function hideRec() {
      if (rec) rec.hidden = true;
    }

    const LB_URL = "https://mantledb.sh/v2/qlex-store-runner/leaders";

    function cleanRows(raw) {
      if (!Array.isArray(raw)) return [];
      return raw.filter((row) => row && (row.name || row.score));
    }

    function readSeedBoard() {
      try {
        return cleanRows(JSON.parse(document.getElementById("qlexGameLeaders")?.textContent || "[]"));
      } catch (e) {
        return [];
      }
    }

    function readLocalBoard() {
      try {
        return cleanRows(JSON.parse(localStorage.getItem(LB_KEY) || "[]"));
      } catch (e) {
        return [];
      }
    }

    function normalizeBoard(rows) {
      const byName = {};
      rows.forEach((row) => {
        const name = String(row.name || "")
          .toUpperCase()
          .replace(/[^A-Z]/g, "")
          .slice(0, 3);
        const score = Math.floor(Number(row.score));
        if (name.length !== 3 || !Number.isFinite(score) || score <= 0) return;
        const at = Number(row.at) || 0;
        if (!byName[name] || score > byName[name].score) {
          byName[name] = { name: name, score: score, at: at };
        }
      });
      return Object.keys(byName)
        .map((k) => byName[k])
        .sort((a, b) => b.score - a.score || a.at - b.at)
        .slice(0, 10);
    }

    function loadBoard() {
      return normalizeBoard(readSeedBoard().concat(readLocalBoard()));
    }

    function persistBoard(list) {
      try {
        localStorage.setItem(LB_KEY, JSON.stringify(list));
      } catch (e) {
        /* ignore */
      }
    }

    async function fetchPublicBoard() {
      try {
        const res = await fetch(LB_URL, { cache: "no-store" });
        if (!res.ok) return [];
        const data = await res.json();
        return cleanRows(data && data.scores ? data.scores : data);
      } catch (e) {
        return [];
      }
    }

    async function pushPublicBoard(list) {
      try {
        await fetch(LB_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ scores: list }),
        });
      } catch (e) {
        /* ignore */
      }
    }

    async function refreshPublicBoard() {
      const remote = await fetchPublicBoard();
      const list = normalizeBoard(remote.concat(readSeedBoard()).concat(readLocalBoard()));
      persistBoard(list);
      renderBoard(list, state.youEntry);
      const remoteTop = normalizeBoard(remote);
      if (list.length && JSON.stringify(list) !== JSON.stringify(remoteTop)) {
        pushPublicBoard(list);
      }
      return list;
    }

    function submitPublicScore(name, score) {
      const form = document.getElementById("qlexGameScoreForm");
      if (!form) return;
      const author = form.querySelector('[name="comment[author]"]');
      const email = form.querySelector('[name="comment[email]"]');
      const body = form.querySelector('[name="comment[body]"]');
      if (author) author.value = name;
      if (email) email.value = name.toLowerCase() + Date.now() + "@qlex.store";
      if (body) body.value = String(Math.max(0, Math.floor(score)));
      form.setAttribute("target", "qlexScoreFrame");
      ["change", "focusin"].forEach((type) => {
        form.dispatchEvent(new Event(type, { bubbles: true }));
      });
      if (typeof form.requestSubmit === "function") form.requestSubmit();
      else form.submit();
    }

    function qualifies(score, list) {
      if (score <= 0) return false;
      if (list.length < 10) return true;
      return score > list[list.length - 1].score;
    }

    function hideName() {
      state.enteringName = false;
      if (namePanel) namePanel.hidden = true;
    }

    function hideBoard() {
      /* Public board stays visible. */
    }

    function paintNameSlots() {
      if (!nameSlots) return;
      const buttons = nameSlots.querySelectorAll(".game-name-letter");
      buttons.forEach((btn, i) => {
        btn.textContent = state.nameLetters[i] || "A";
        btn.classList.toggle("is-active", i === state.nameIndex);
      });
    }

    function renderBoard(list, you) {
      if (!boardPanel || !boardList) return;
      boardList.replaceChildren();
      const rows = list.slice(0, 10);
      rows.forEach((row, i) => {
        const li = document.createElement("li");
        const isYou = !!(you && you.name === row.name && you.score === row.score && you.at === row.at);
        li.className = "game-board-row" + (isYou ? " is-you" : "");
        li.innerHTML =
          "<span>" + String(i + 1).padStart(2, "0") + "</span>" +
          "<span>" + row.name + "</span>" +
          "<span>" + padScore(row.score) + "</span>";
        boardList.appendChild(li);
      });
      if (!rows.length) {
        const empty = document.createElement("li");
        empty.className = "game-board-row";
        empty.textContent = "No scores yet";
        boardList.appendChild(empty);
      }
      boardPanel.hidden = false;
    }

    function cycleLetter(dir) {
      const i = state.nameIndex;
      const cur = LETTERS.indexOf(state.nameLetters[i] || "A");
      const next = (cur + dir + LETTERS.length) % LETTERS.length;
      state.nameLetters[i] = LETTERS[next];
      paintNameSlots();
    }

    function moveNameSlot(dir) {
      state.nameIndex = Math.max(0, Math.min(2, state.nameIndex + dir));
      paintNameSlots();
    }

    function openNameEntry(score) {
      const panel = document.getElementById("qlexGameName") || namePanel;
      state.enteringName = true;
      state.pendingScore = score;
      state.nameLetters = ["A", "A", "A"];
      state.nameIndex = 0;
      hideBoard();
      hideRec();
      if (panel) {
        panel.hidden = false;
        panel.removeAttribute("hidden");
      }
      paintNameSlots();
    }

    function saveNameEntry() {
      if (!state.enteringName) return;
      const name = state.nameLetters.join("");
      const score = state.pendingScore;
      const at = Date.now();
      let list = loadBoard();
      const existing = list.findIndex((row) => row.name === name);
      if (existing >= 0) {
        if (score > list[existing].score) list[existing] = { name: name, score: score, at: at };
      } else {
        list.push({ name: name, score: score, at: at });
      }
      list = list.sort((a, b) => b.score - a.score || a.at - b.at).slice(0, 10);
      persistBoard(list);
      pushPublicBoard(list);
      submitPublicScore(name, score);
      state.youEntry = { name: name, score: score, at: at };
      hideName();
      renderBoard(list, state.youEntry);
      showRec();
    }

    function showRec() {
      if (!rec || !catalog.length) return;
      const pool = catalog.filter((p) => p.handle !== lastRecHandle);
      const pick = pool[Math.floor(Math.random() * pool.length)] || catalog[0];
      lastRecHandle = pick.handle;
      if (recLink) recLink.href = pick.url || "#";
      if (recImg) {
        recImg.src = pick.image || "";
        recImg.alt = pick.title || "";
      }
      if (recTitle) recTitle.textContent = pick.title || "";
      if (recPrice) recPrice.textContent = pick.price || "";
      rec.hidden = false;
    }

    function setOverlay(text) {
      if (overlay) {
        overlay.hidden = !text;
        overlay.textContent = text || "";
      }
    }

    function reset() {
      state.running = true;
      state.dead = false;
      state.diedAt = 0;
      state.time = 0;
      state.score = 0;
      state.scoreAcc = 0;
      state.speed = SPEED_START;
      state.milestone = 0;
      state.holdJump = false;
      state.holdLeft = 0;
      duckLatch = false;
      state.duckAmt = 0;
      state.ducking = false;
      const duckBtn = document.getElementById("qlexGameDuckBtn");
      if (duckBtn) {
        duckBtn.classList.remove("is-held");
        duckBtn.setAttribute("aria-pressed", "false");
      }
      state.player.w = state.player.standW;
      state.player.h = state.player.standH;
      state.obstacles = [];
      state.gapLeft = 360;
      state.flyGap = 780;
      state.scroll = 0;
      state.player.vy = 0;
      state.player.grounded = true;
      state.player.y = state.groundY - state.player.h;
      setOverlay("");
      hideRec();
      hideName();
      hideBoard();
      state.youEntry = null;
    }

    function startJump() {
      if (state.enteringName) return;
      if (state.dead) {
        if (Date.now() - state.diedAt < 700) return;
        reset();
      }
      if (!state.running) {
        reset();
      }
      duckLatch = false;
      if (state.ducking) setDuck(false);
      if (!state.player.grounded) return;
      state.player.vy = JUMP_V;
      state.player.grounded = false;
      state.holdJump = true;
      state.holdLeft = JUMP_HOLD_FRAMES;
    }

    function endJump() {
      state.holdJump = false;
    }

    function setDuck(on) {
      if (state.dead) return;
      state.ducking = !!on;
      if (on && state.player.grounded) state.duckAmt = 1;
      if (!state.player.grounded && on) {
        state.player.vy = Math.max(state.player.vy, 7);
      }
      const btn = document.getElementById("qlexGameDuckBtn");
      if (btn) {
        btn.classList.toggle("is-held", state.ducking);
        btn.setAttribute("aria-pressed", state.ducking ? "true" : "false");
      }
    }

    const GROUND_KINDS = ["cone", "cone", "barrier", "sign", "barrel", "lights"];
    const SPR_SCALE = 4;
    const OBSTACLE_SIZE = {
      cone: { w: 9 * SPR_SCALE, h: 9 * SPR_SCALE },
      barrier: { w: 15 * SPR_SCALE, h: 8 * SPR_SCALE },
      sign: { w: 7 * SPR_SCALE, h: 12 * SPR_SCALE },
      barrel: { w: 8 * SPR_SCALE, h: 9 * SPR_SCALE },
      lights: { w: 7 * SPR_SCALE, h: 11 * SPR_SCALE },
      flyer: { w: 12 * SPR_SCALE, h: 7 * SPR_SCALE },
    };

    function rightmostObstacle() {
      let best = null;
      for (let i = 0; i < state.obstacles.length; i++) {
        const o = state.obstacles[i];
        if (!best || o.x + o.w > best.x + best.w) best = o;
      }
      return best;
    }

    function minSep(prev, nextKind) {
      const nextW = (OBSTACLE_SIZE[nextKind] || {}).w || 36;
      const prevW = prev ? prev.w : nextW;
      const mixed = prev && ((prev.kind === "flyer") !== (nextKind === "flyer"));
      return 200 + state.player.w + Math.max(prevW, nextW) + state.speed * 36 + (mixed ? 120 : 0);
    }

    function canPlace(kind) {
      const spawnX = WORLD_W + 20;
      const spawnW = OBSTACLE_SIZE[kind].w;
      const pad = state.player.w + 48;
      for (let i = 0; i < state.obstacles.length; i++) {
        const o = state.obstacles[i];
        if (spawnX < o.x + o.w + pad && spawnX + spawnW + pad > o.x) return false;
      }
      const prev = rightmostObstacle();
      if (prev && spawnX - (prev.x + prev.w) < minSep(prev, kind)) return false;
      return true;
    }

    function afterSpawn(kind) {
      const dummy = { kind: kind, w: OBSTACLE_SIZE[kind].w };
      return minSep(dummy, kind) + Math.round(Math.random() * 90);
    }

    function spawnGround() {
      const kind = GROUND_KINDS[Math.floor(Math.random() * GROUND_KINDS.length)];
      if (!canPlace(kind)) {
        state.gapLeft = 36;
        return;
      }
      const size = OBSTACLE_SIZE[kind];
      state.obstacles.push({
        kind: kind,
        x: WORLD_W + 20,
        y: state.groundY - size.h,
        w: size.w,
        h: size.h,
      });
      state.gapLeft = afterSpawn(kind);
    }

    function spawnFlyer() {
      if (!canPlace("flyer")) {
        state.flyGap = 36;
        return;
      }
      const size = OBSTACLE_SIZE.flyer;
      const high = Math.random() > 0.4;
      const lift = high ? state.player.duckH + 18 : 28;
      state.obstacles.push({
        kind: "flyer",
        x: WORLD_W + 20,
        y: state.groundY - size.h - lift,
        w: size.w,
        h: size.h,
      });
      state.flyGap = afterSpawn("flyer") + 220;
    }

    const HITBOXES = {
      cone: [
        { x: 0.30, y: 0.00, w: 0.40, h: 0.42 },
        { x: 0.10, y: 0.38, w: 0.80, h: 0.56 },
      ],
      barrier: [{ x: 0.04, y: 0.16, w: 0.92, h: 0.56 }],
      sign: [
        { x: 0.14, y: 0.02, w: 0.72, h: 0.56 },
        { x: 0.36, y: 0.56, w: 0.28, h: 0.40 },
      ],
      barrel: [{ x: 0.10, y: 0.06, w: 0.80, h: 0.88 }],
      lights: [
        { x: 0.10, y: 0.00, w: 0.80, h: 0.40 },
        { x: 0.34, y: 0.38, w: 0.32, h: 0.58 },
      ],
      flyer: [{ x: 0.10, y: 0.12, w: 0.80, h: 0.70 }],
    };

    function playerBoxes(p) {
      if (state.duckAmt > 0.45 && p.grounded) {
        return [
          { x: p.x + p.w * 0.16, y: p.y + p.h * 0.10, w: p.w * 0.68, h: p.h * 0.52 },
          { x: p.x + p.w * 0.10, y: p.y + p.h * 0.62, w: p.w * 0.80, h: p.h * 0.30 },
        ];
      }
      return [
        { x: p.x + p.w * 0.30, y: p.y + p.h * 0.04, w: p.w * 0.40, h: p.h * 0.26 },
        { x: p.x + p.w * 0.38, y: p.y + p.h * 0.28, w: p.w * 0.24, h: p.h * 0.48 },
        { x: p.x + p.w * 0.12, y: p.y + p.h * 0.78, w: p.w * 0.76, h: p.h * 0.18 },
      ];
    }

    function rectsOverlap(a, b) {
      return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
    }

    function hitsObstacle(p, o) {
      const local = HITBOXES[o.kind] || [{ x: 2, y: 2, w: o.w - 4, h: o.h - 4 }];
      const bodies = playerBoxes(p);
      for (let i = 0; i < local.length; i++) {
        const box = {
          x: o.x + local[i].x * o.w,
          y: o.y + local[i].y * o.h,
          w: local[i].w * o.w,
          h: local[i].h * o.h,
        };
        for (let j = 0; j < bodies.length; j++) {
          if (rectsOverlap(bodies[j], box)) return true;
        }
      }
      return false;
    }

    function px(color, x, y, w, h) {
      ctx.fillStyle = color;
      ctx.fillRect(Math.round(x), Math.round(y), Math.max(1, Math.round(w)), Math.max(1, Math.round(h)));
    }

    function spritePal(c) {
      return { X: c.ink, W: c.warn, A: c.accent, M: c.muted, S: c.stripe };
    }

    const sprCanvasCache = {};
    function spriteCanvas(rows, pal, scale) {
      const key = rows.join("/") + "|" + pal.X + pal.W + pal.A + pal.M + "|" + scale;
      if (sprCanvasCache[key]) return sprCanvasCache[key];
      const c = document.createElement("canvas");
      c.width = rows[0].length * scale;
      c.height = rows.length * scale;
      const x = c.getContext("2d");
      x.imageSmoothingEnabled = false;
      for (let r = 0; r < rows.length; r++) {
        const row = rows[r];
        for (let col = 0; col < row.length; col++) {
          const color = pal[row[col]];
          if (!color) continue;
          x.fillStyle = color;
          x.fillRect(col * scale, r * scale, scale, scale);
        }
      }
      sprCanvasCache[key] = c;
      return c;
    }

    function blit(rows, x, y, pal, scale) {
      const s = scale || SPR_SCALE;
      ctx.drawImage(spriteCanvas(rows, pal, s), x, y);
    }

    function blitIn(rows, box, pal, scale) {
      const s = scale || SPR_SCALE;
      const img = spriteCanvas(rows, pal, s);
      ctx.drawImage(
        img,
        Math.round(box.x + (box.w - img.width) / 2),
        Math.round(box.y + box.h - img.height)
      );
    }

    const SPR = {
      qRun0: [
        "..............",
        "...XXXXXX.....",
        "..XX....XX....",
        "..XX.AA.XX....",
        "..XX....XX....",
        "..XX....XX....",
        "...XXXXXX.....",
        "....XXXX.XXX..",
        ".........XX...",
        "...XX.........",
        "...XX..XX.....",
        ".......XX.....",
      ],
      qRun1: [
        "..............",
        "...XXXXXX.....",
        "..XX....XX....",
        "..XX.AA.XX....",
        "..XX....XX....",
        "..XX....XX....",
        "...XXXXXX.....",
        "....XXXX.XXX..",
        ".........XX...",
        ".....XX.......",
        "...XXXX.......",
        "...XX.........",
      ],
      qJump: [
        "..............",
        "...XXXXXX.....",
        "..XX....XX....",
        "..XX.AA.XX....",
        "..XX....XX....",
        "..XX....XX....",
        "...XXXXXX.....",
        "....XXXX.XXX..",
        ".........XX...",
        "....XX.XX.....",
        "....XX.XX.....",
        "..............",
      ],
      qDuck: [
        "..................",
        "..................",
        "..XXXXXXXX.XXX....",
        ".XX......XX.XX....",
        ".XX..AA..XX.......",
        ".XX......XX.......",
        "..XXXXXXXX........",
        "....XX..XX........",
      ],
      qDead: [
        "..................",
        ".........XX.......",
        "..XXXXXXXX.XXX....",
        ".XX......XX.XX....",
        ".XX..AA..AA.......",
        ".XX......XX.......",
        "..XXXXXXXX........",
        "..................",
      ],
      cone: [
        "....W....",
        "...WWW...",
        "...WXW...",
        "..WWWWW..",
        "..WXXXW..",
        ".WWWWWWW.",
        ".WXXXXXW.",
        "WWWWWWWWW",
        "XXXXXXXXX",
      ],
      barrier: [
        "...............",
        "XWWXXWWXXWWXXWW",
        "WXXWWXXWWXXWWXX",
        "XWWXXWWXXWWXXWW",
        "WXXWWXXWWXXWWXX",
        "XWWXXWWXXWWXXWW",
        "X.............X",
        "X.............X",
      ],
      sign: [
        "...W...",
        "..WWW..",
        ".WXXXW.",
        ".WXAXW.",
        ".WXXXW.",
        ".WXAXW.",
        "..WWW..",
        "...W...",
        "...M...",
        "...M...",
        "...M...",
        "..MMM..",
      ],
      barrel: [
        ".XXXXXX.",
        "WWWWWWWW",
        "W......W",
        "WWWWWWWW",
        "W......W",
        "WWWWWWWW",
        "W......W",
        "WWWWWWWW",
        ".XXXXXX.",
      ],
      lights: [
        ".XXXXX.",
        "XAAAAAX",
        "XWWWWWX",
        "XMMMMMX",
        "..XMX..",
        "..XMX..",
        "..XMX..",
        "..XMX..",
        "..XMX..",
        "..XMX..",
        ".MMMMM.",
      ],
      flyer0: [
        "...XXXX.....",
        "XXXXXXXXXWW.",
        "...XX....A..",
        "...XX.......",
        "............",
        "............",
        "............",
      ],
      flyer1: [
        "............",
        "XXXXXXXXXWW.",
        "...XX....A..",
        "...XXXX.....",
        "............",
        "............",
        "............",
      ],
    };

    function drawPlayer(p, colors) {
      const dark = document.documentElement.getAttribute("data-theme") === "dark";
      const ducked = (state.ducking || state.duckAmt > 0.15) && p.grounded && !state.dead;
      if (ducked) {
        const sheet = duckSheet(dark);
        if (sheet) {
          const aspect = sheet.width / Math.max(1, sheet.height);
          const visH = 36;
          const visW = visH * aspect;
          const cx = p.x + visW * 0.48;
          const cy = state.groundY - visH * 0.5;
          ctx.save();
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = "high";
          ctx.translate(Math.round(cx), Math.round(cy));
          ctx.drawImage(sheet, -visW / 2, -visH / 2, visW, visH);
          ctx.restore();
          return;
        }
        blitIn(SPR.qDuck, { x: p.x - 4, y: p.y, w: p.w + 8, h: p.h }, spritePal(colors), SPR_SCALE);
        return;
      }

      const sheet = skaterSheet(dark);
      if (!sheet) {
        const pal = spritePal(colors);
        const step = Math.floor(state.time / 5) % 2;
        if (state.dead) blitIn(SPR.qDead, p, pal, SPR_SCALE);
        else if (!p.grounded) blitIn(SPR.qJump, p, pal, SPR_SCALE);
        else blitIn(step ? SPR.qRun1 : SPR.qRun0, p, pal, SPR_SCALE);
        return;
      }

      const tilt = state.dead ? 0.9 : !p.grounded ? Math.max(-0.22, Math.min(0.08, p.vy * 0.02)) : 0;
      ctx.save();
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.translate(Math.round(p.x + p.w / 2), Math.round(p.y + p.h / 2));
      ctx.rotate(tilt);
      ctx.scale(-1, 1);
      ctx.drawImage(sheet, -p.w / 2, -p.h / 2, p.w, p.h);
      ctx.restore();
    }

    function drawCone(o, c) {
      blitIn(SPR.cone, o, spritePal(c));
    }

    function drawBarrier(o, c) {
      blitIn(SPR.barrier, o, spritePal(c));
    }

    function drawSign(o, c) {
      blitIn(SPR.sign, o, spritePal(c));
    }

    function drawBarrel(o, c) {
      blitIn(SPR.barrel, o, spritePal(c));
    }

    function drawLights(o, c) {
      blitIn(SPR.lights, o, spritePal(c));
    }

    function drawFlyer(o, c) {
      blitIn(Math.floor(state.time / 14) % 2 ? SPR.flyer1 : SPR.flyer0, o, spritePal(c));
    }

    function drawObstacle(o, colors) {
      if (o.kind === "cone") drawCone(o, colors);
      else if (o.kind === "barrier") drawBarrier(o, colors);
      else if (o.kind === "sign") drawSign(o, colors);
      else if (o.kind === "barrel") drawBarrel(o, colors);
      else if (o.kind === "flyer") drawFlyer(o, colors);
      else drawLights(o, colors);
    }

    function wrapX(x, span) {
      return ((x % span) + span) % span;
    }

    function eachWrap(origin, speed, span, width, drawFn) {
      const x = wrapX(origin - Math.round(state.scroll * speed), span);
      if (x < WORLD_W && x + width > 0) drawFn(x);
      const left = x - span;
      if (left < WORLD_W && left + width > 0) drawFn(left);
    }

    function forTiles(scroll, spacing, drawFn) {
      const snapped = Math.round(scroll);
      const off = ((snapped % spacing) + spacing) % spacing;
      for (let x = -off - spacing; x < WORLD_W + spacing; x += spacing) {
        drawFn(x, Math.floor((snapped + x) / spacing + 1e-6));
      }
    }

    function drawWillis(x, base, color) {
      px(color, x + 12, base - 128, 2, 18);
      px(color, x + 28, base - 132, 2, 22);
      px(color, x + 4, base - 110, 34, 110);
    }

    function drawHancock(x, base, color) {
      px(color, x + 16, base - 136, 2, 24);
      px(color, x + 8, base - 112, 22, 40);
      px(color, x + 2, base - 72, 34, 72);
    }

    function drawAon(x, base, color) {
      px(color, x + 8, base - 96, 2, 8);
      px(color, x, base - 88, 20, 88);
    }

    function drawTrump(x, base, color) {
      px(color, x + 8, base - 90, 20, 36);
      px(color, x, base - 54, 36, 54);
    }

    function drawWrigley(x, base, color) {
      px(color, x + 6, base - 78, 2, 8);
      px(color, x + 2, base - 70, 10, 8);
      px(color, x + 4, base - 62, 6, 6);
      px(color, x, base - 56, 14, 56);
      px(color, x + 16, base - 44, 12, 44);
    }

    function drawTribune(x, base, color) {
      px(color, x + 8, base - 72, 2, 8);
      px(color, x + 4, base - 64, 10, 6);
      px(color, x + 2, base - 58, 14, 8);
      px(color, x, base - 50, 18, 50);
    }

    function drawStep(x, base, w, h, color) {
      px(color, x + 6, base - h, w - 12, Math.round(h * 0.28));
      px(color, x + 3, base - Math.round(h * 0.72), w - 6, Math.round(h * 0.28));
      px(color, x, base - Math.round(h * 0.44), w, Math.round(h * 0.44));
    }

    function drawPierWheel(x, base, color) {
      px(color, x + 16, base - 36, 4, 20);
      px(color, x + 10, base - 44, 16, 4);
      px(color, x + 6, base - 40, 4, 8);
      px(color, x + 26, base - 40, 4, 8);
      px(color, x + 10, base - 28, 16, 4);
      px(color, x + 4, base - 16, 28, 4);
      px(color, x, base - 12, 36, 12);
    }

    function buildingWidth(b) {
      if (b.kind === "willis") return 42;
      if (b.kind === "hancock" || b.kind === "trump") return 38;
      if (b.kind === "marina") return 44;
      if (b.kind === "pier") return 40;
      if (b.kind === "wrigley") return 30;
      if (b.kind === "aon") return 22;
      if (b.kind === "tribune") return 18;
      return b.w || 24;
    }

    function drawSkylineBuilding(b, x, base, color) {
      if (b.kind === "willis") drawWillis(x, base, color);
      else if (b.kind === "hancock") drawHancock(x, base, color);
      else if (b.kind === "aon") drawAon(x, base, color);
      else if (b.kind === "trump") drawTrump(x, base, color);
      else px(color, x, base - (b.h || 36), b.w || 24, b.h || 36);
    }

    function drawBackground(colors) {
      px(colors.sky, 0, 0, WORLD_W, state.groundY + 10);

      clouds.forEach((cloud) => {
        eachWrap(cloud.x, 0.08, WORLD_W + 120, cloud.w + 8, (x) => {
          px(colors.far, x, cloud.y, cloud.w, 5);
          px(colors.far, x + 8, cloud.y - 4, cloud.w - 14, 5);
        });
      });

      const horizon = state.groundY - 4;
      skyline.forEach((b) => {
        eachWrap(b.x, 0.18, SKYLINE_SPAN, buildingWidth(b), (x) => {
          drawSkylineBuilding(b, x, horizon, colors.far);
        });
      });

      px(colors.rail, 0, state.groundY - 2, WORLD_W, 2);
      px(colors.road, 0, state.groundY + 10, WORLD_W, 26);
      px(colors.ground, 0, state.groundY + 10, WORLD_W, 2);

      forTiles(state.scroll, 72, (x) => {
        px(colors.dash, x, state.groundY + 22, 16, 2);
      });
    }

    function die() {
      state.dead = true;
      state.running = false;
      state.diedAt = Date.now();
      if (state.score > hiScore) {
        hiScore = state.score;
        try {
          localStorage.setItem(HI_KEY, String(hiScore));
        } catch (e) {
          /* ignore */
        }
      }
      setOverlay("G A M E  O V E R");
      const list = loadBoard();
      if (qualifies(state.score, list)) {
        openNameEntry(state.score);
      } else {
        renderBoard(list, state.youEntry);
        showRec();
      }
    }

    let lastTs = 0;
    function tick(ts) {
      if (!lastTs) lastTs = ts || 0;
      let dt = ((ts || lastTs) - lastTs) / (1000 / 60);
      lastTs = ts || lastTs;
      if (!Number.isFinite(dt) || dt <= 0) dt = 1;
      if (dt > 2.4) dt = 2.4;

      const colors = themeInk();
      ctx.clearRect(0, 0, WORLD_W, WORLD_H);
      drawBackground(colors);

      if (state.running && !state.dead) {
        state.time += dt;
        state.scoreAcc += 0.15 * (state.speed / SPEED_START) * dt;
        if (state.scoreAcc >= 1) {
          state.scoreAcc -= 1;
          state.score += 1;
        }

        const mile = Math.floor(state.score / 100);
        if (state.score > 0 && mile > state.milestone) {
          state.milestone = mile;
          state.speed = Math.min(SPEED_MAX, state.speed + SPEED_STEP);
        }

        state.scroll += state.speed * dt;
        state.gapLeft -= state.speed * dt;
        if (state.gapLeft <= 0) spawnGround();
        if (state.score > 220) {
          state.flyGap -= state.speed * dt;
          if (state.flyGap <= 0) spawnFlyer();
        }

        if (state.holdJump && state.holdLeft > 0 && state.player.vy < 0) {
          state.player.vy += JUMP_HOLD * dt;
          state.holdLeft -= dt;
        }
        state.player.vy += GRAVITY * dt;
        state.player.y += state.player.vy * dt;

        const wantDuck = state.ducking && state.player.grounded;
        if (wantDuck) state.duckAmt = 1;
        else state.duckAmt += (0 - state.duckAmt) * Math.min(1, 0.45 * dt);
        state.player.w = state.player.standW + (state.player.duckW - state.player.standW) * state.duckAmt;
        state.player.h = state.player.standH + (state.player.duckH - state.player.standH) * state.duckAmt;

        const floor = state.groundY - state.player.h;
        if (state.player.grounded || state.player.y >= floor) {
          state.player.y = floor;
          state.player.vy = 0;
          state.player.grounded = true;
          state.holdJump = false;
          state.holdLeft = 0;
        }

        state.obstacles.forEach((o) => {
          o.x -= state.speed * dt;
        });
        state.obstacles = state.obstacles.filter((o) => o.x + o.w > -24);

        for (let i = 0; i < state.obstacles.length; i++) {
          if (hitsObstacle(state.player, state.obstacles[i])) {
            die();
            break;
          }
        }
      } else if (!state.dead) {
        state.time += dt * 0.35;
      }

      drawPlayer(state.player, colors);
      if (!state.dead) {
        state.obstacles.forEach((o) => drawObstacle(o, colors));
      }

      if (hud) hud.textContent = "HI " + padScore(hiScore) + "   " + padScore(state.score);
      requestAnimationFrame(tick);
    }

    function onKeyDown(e) {
      if (state.enteringName) {
        if (e.code === "ArrowUp" || e.code === "KeyW") {
          e.preventDefault();
          cycleLetter(1);
        } else if (e.code === "ArrowDown" || e.code === "KeyS") {
          e.preventDefault();
          cycleLetter(-1);
        } else if (e.code === "ArrowLeft") {
          e.preventDefault();
          moveNameSlot(-1);
        } else if (e.code === "ArrowRight") {
          e.preventDefault();
          moveNameSlot(1);
        } else if (e.code === "Enter") {
          e.preventDefault();
          saveNameEntry();
        } else if (e.code === "Space") {
          e.preventDefault();
          if (state.nameIndex < 2) moveNameSlot(1);
          else saveNameEntry();
        }
        return;
      }
      if (e.code === "Space" || e.code === "ArrowUp") {
        e.preventDefault();
        if (!e.repeat) startJump();
      }
      if (e.code === "ArrowDown" || e.code === "KeyS") {
        e.preventDefault();
        duckLatch = false;
        setDuck(true);
      }
    }

    function onKeyUp(e) {
      if (state.enteringName) {
        if (e.code === "Space" || e.code === "ArrowUp" || e.code === "ArrowDown") {
          e.preventDefault();
        }
        return;
      }
      if (e.code === "Space" || e.code === "ArrowUp") {
        e.preventDefault();
        endJump();
      }
      if (e.code === "ArrowDown" || e.code === "KeyS") {
        e.preventDefault();
        duckLatch = false;
        setDuck(false);
      }
    }

    size();
    renderBoard(loadBoard(), state.youEntry);
    refreshPublicBoard();
    window.addEventListener("resize", size);
    window.addEventListener("orientationchange", () => setTimeout(size, 120));
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", size);
    }
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("keyup", onKeyUp);
    if (nameSlots) {
      nameSlots.addEventListener("click", (e) => {
        const btn = e.target.closest(".game-name-letter");
        if (!btn || !state.enteringName) return;
        const i = parseInt(btn.getAttribute("data-i"), 10);
        if (i === state.nameIndex) cycleLetter(1);
        else {
          state.nameIndex = i;
          paintNameSlots();
        }
      });
    }
    if (nameSave) {
      nameSave.addEventListener("click", (e) => {
        e.preventDefault();
        saveNameEntry();
      });
    }

    function bindHold(el, onDown, onUp) {
      if (!el) return;
      let pressed = false;
      const down = (e) => {
        if (e.button && e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        try {
          el.setPointerCapture(e.pointerId);
        } catch (err) {
          /* ignore */
        }
        pressed = true;
        el.classList.add("is-held");
        onDown(e);
      };
      const up = () => {
        if (!pressed) return;
        pressed = false;
        el.classList.remove("is-held");
        onUp();
      };
      el.addEventListener("pointerdown", down);
      el.addEventListener("pointerup", up);
      el.addEventListener("pointercancel", up);
      el.addEventListener("lostpointercapture", up);
      el.addEventListener("contextmenu", (e) => e.preventDefault());
    }

    bindHold(
      document.getElementById("qlexGameJumpBtn"),
      () => {
        if (!state.enteringName) startJump();
      },
      endJump
    );
    bindHold(
      document.getElementById("qlexGameDuckBtn"),
      () => {
        if (state.enteringName || state.dead) return;
        duckPressAt = Date.now();
        setDuck(true);
      },
      () => {
        if (state.enteringName || state.dead) return;
        const tapped = Date.now() - duckPressAt < 280;
        if (tapped) {
          duckLatch = !duckLatch;
          setDuck(duckLatch);
        } else {
          duckLatch = false;
          setDuck(false);
        }
      }
    );

    bindHold(
      canvasEl,
      () => {
        if (!state.enteringName) startJump();
      },
      endJump
    );
    canvasEl.addEventListener("contextmenu", (e) => e.preventDefault());
    requestAnimationFrame(tick);
  }
})();
